import React = require("react");
import { getSurveyStatus, Survey, LanguageCode, SurveyTheme, stringUtil } from '../../../amorg-common';
import { Button } from "../../../designSystem/button/Button";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { createSurveyQuestion, deleteSurveyTheme, moveSurveyTheme, updateSurveyThemeText } from "../../../api/surveyClientApi";
import { fieldValidation, surveyHelper } from '../../../amorg-common';
import { Flex, FlexItem } from "../../../designSystem/compositeComponents/FlexHelpers";
import { EditableText } from '../../../designSystem/compositeComponents/EditableText';
import { QuestionListItem } from "./QuestionListItem";
import { ListRow } from "../../../designSystem/compositeComponents/ListRow";
import { AnimatedCollapsibleContent } from "../../../designSystem/collapsible/AnimatedCollapsibleContent";
import { ToolBarButton } from "../../../designSystem/compositeComponents/ButtonToolBar";
import { InputMessage } from "../../../designSystem/InputMessage";


//type InEditQuestionState = { questionIndex:number, question:SurveyQuestion };

type ThemedQuestionListItemProps = {
    survey: Survey,
    themes: SurveyTheme[],
    theme: SurveyTheme,
    themeIndex: number,
    allIndicators: string[]
    languageCode:LanguageCode,
    onSurveyUpdated: () => void
}
export function ThemedQuestionList(props: ThemedQuestionListItemProps): JSX.Element 
{
    const [expanded, setExpanded] = React.useState(true);

    async function handleThemeSave(newValue: string) {
        if ((await updateSurveyThemeText(props.survey.id, props.themeIndex, props.languageCode, newValue)).isSuccess){
            props.onSurveyUpdated();
        }
    }

    async function handleClickAddNewQuestion() {
        const name = stringUtil.generateNextSequenceName('Nyt spørgsmål', props.theme.questions.map(q => q.title));
        if (await createSurveyQuestion(props.survey.id, props.themeIndex, [], name))
            props.onSurveyUpdated();
    }

    async function handleClickDeleteTheme() {
        if (await deleteSurveyTheme(props.survey.id, props.themeIndex))
            props.onSurveyUpdated();
    }

    async function handleMoveTheme(move: 'up' | 'down') {
        if (move === 'up') {
            if (props.themeIndex > 0) {
                await moveSurveyTheme(props.survey.id, props.themeIndex, props.themeIndex - 1);
                props.onSurveyUpdated();
            }
        }
        if (move === 'down') {
            if (props.themeIndex < props.survey.themes.length - 1) {
                await moveSurveyTheme(props.survey.id, props.themeIndex, props.themeIndex + 1);
                props.onSurveyUpdated();
            }
        }
    }

    const disableEdit = !getSurveyStatus(props.survey).canEdit;

    return (
        <div>
            <ListRow styleVariant="neutral">
                    <Flex flexDirection="column">
                        <Flex justifyContent="space-between">
                            <FlexItem flexGrow="1">
                                <EditableText
                                    styleMode='H2'
                                    ariaLabel="Spørgsmålstema"
                                    placeholder="Tema"
                                    value={surveyHelper.getThemeValue(props.survey, props.themeIndex, props.languageCode)}
                                    validator={(currentValue) =>
                                        fieldValidation.surveyTheme.name(currentValue)
                                                ? { valid:true }
                                                : { valid:false, errorMessage:`Ugyldig tekst. Skal udfyldes med maks. 200 (${currentValue.length}) tegn.`}
                                    }
                                    onSave={(value, isValid) => {
                                        if(isValid)
                                            handleThemeSave(value);
                                    }}
                                    disabled={disableEdit} />
                                    <InputMessage indent>{`Tema ${props.themeIndex+1}`}</InputMessage>
                            </FlexItem>
                            
                            {!disableEdit &&
                                <>
                                <ToolBarButton
                                    variant="text"
                                    icon="arrows_chevron_chevronUp"
                                    tooltip='Flyt tema op'
                                    onClick={() => handleMoveTheme('up')} />

                                <ToolBarButton
                                    variant="text"
                                    icon="arrows_chevron_chevronDown"
                                    tooltip='Flyt tema ned'
                                    onClick={() => handleMoveTheme('down')} />

                                <ToolBarButton
                                    variant="destructive-text"
                                    icon='interface_actions_delete'
                                    tooltip='Slet tema'
                                    onClick={handleClickDeleteTheme} />
                                </>
                            }

                            <Button
                                variant="text"
                                onClick={() => setExpanded(!expanded)}
                                icon={ expanded ? 'arrows_chevron_chevronUp' : 'arrows_chevron_chevronDown' } />
                        </Flex>

                        
                    </Flex>
            </ListRow>
            <AnimatedCollapsibleContent open={expanded}>
                <>
                    {props.theme.questions.map((q, i) =>{
                        const prevQuestions = props.themes.filter((_,index) => index < props.themeIndex).flatMap(t => t.questions);
                        const offset = prevQuestions.length;

                        return (
                            <QuestionListItem key={i}
                                survey={props.survey}
                                languageCode={props.languageCode}
                                originalQuestionIndex={offset + i}
                                allIndicators={props.allIndicators}
                                surveyId={props.survey.id}
                                themeIndex={props.themeIndex}
                                themes={props.themes}
                                questionIndex={i}
                                question={q}
                                questionsInThisTheme={props.theme.questions.length}
                                disableEdit={disableEdit}
                                onQuestionUpdated={props.onSurveyUpdated}
                            // onMove={props.onMove}
                            />
                        );
                    })}
                    
                    <ButtonRow variant="stretched" style={{marginLeft:'48px'}}>
                        <Button
                            variant="light" 
                            size='magnum'
                            onClick={handleClickAddNewQuestion}
                            icon="actions_plus"
                            text={"Tilføj spørgsmål"}
                            disabled={disableEdit} />
                    </ButtonRow>
                </>

            </AnimatedCollapsibleContent>
        </div> 
    );
}